import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion';
import Table from 'react-bootstrap/Table';
import ProfileService from '../services/Profile';
// import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
// import { Chart } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
// import {faker}  from 'Faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'My Performance (Target vs Actual)',
    },
  },
};

function addLeadingZero(num) {
  // Convert number to string
  const strNum = num.toString();

  // If the number has only one digit, add a leading zero
  if (strNum.length === 1) {
    return '0' + strNum;
  }

  // Otherwise, return the original number as string
  return strNum;
}

function getLast6Months() {
  // Array to hold month names
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Get current date
  const currentDate = new Date();

  // Initialize an array to hold the names and positions of the last 6 months
  const last6Months = [];

  // Loop to get names and positions of last 6 months
  for (let i = 5; i >= 0; i--) {
    const targetDate = new Date();
    targetDate.setMonth(currentDate.getMonth() - i);
    const monthName = monthNames[targetDate.getMonth()];
    const position = monthNames.indexOf(monthName) + 1; // Position starts from 1 for the most recent month
    const yearMonth = new Date(new Date().setMonth(currentDate.getMonth() - i)).getFullYear() + '-' + addLeadingZero(position);
    last6Months.push({ name: monthName, position: position, yearMonth: yearMonth });
  }

  return last6Months;
}

// Call the function and log the result
const getLastSixMonths = getLast6Months();

var labels = [];
getLastSixMonths.map((data) => {
  labels.push(data.name);
})
const toDay = addLeadingZero(new Date().getDate());
const start_Date = getLastSixMonths[0].yearMonth + '-01';
const end_Date = getLastSixMonths[5].yearMonth + '-' + toDay;

// export const data = {
//   labels,
//   datasets: [
//     {
//       label: 'Actual',
//       // data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
//       data: labels.map(() => Math.floor(Math.random() * 100)),
//       backgroundColor: 'rgba(255, 99, 132, 0.5)',
//     },
//     {
//       label: 'Target',
//       data: labels.map(() => Math.floor(Math.random() * 100)),
//       backgroundColor: 'rgba(53, 162, 235, 0.5)',
//     },
//   ],
// };

function array_values(input) {
  const tmpArr = []
  let key = ''
  for (key in input) {
    tmpArr[tmpArr.length] = input[key]
  }
  return tmpArr
}

const Performance = () => {

  const [months, setMonths] = useState(labels);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(start_Date);
  const [endDate, setEndDate] = useState(end_Date);
  const [salesTarget, setSalesTarget] = useState([]);
  const [totalSales, setTotalSales] = useState([]);

  const [data, setData] = useState({}); // data for chart
  const [haveData, setHaveData] = useState(false); //here
  const [saleTargetDetails, setSaleTargetDetails] = useState({});

  useEffect(() => {
    const MyPerformance = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const MyPerformanceResponse = await ProfileService.getMyPerformance(token, startDate, endDate)

        if (MyPerformanceResponse.success == true) {
          let saleTargetDetails = MyPerformanceResponse.response.saleTargetDetails;

          setSaleTargetDetails(saleTargetDetails);
          let monthWiseTarget = [];
          let monthWiseActual = [];
          let tableData = [];
          /*saleTargetDetails.map((productWise, index) => {
            productWise.sale_target_achivement_detail.map((singleMonthData) => {
              getLastSixMonths.map((singleMonthObj) => {

                if (singleMonthData.sales_target_month == singleMonthObj.yearMonth) {
                  if (monthWiseTarget[singleMonthObj.yearMonth] === undefined) {
                    monthWiseTarget[singleMonthObj.yearMonth] = 0;
                  }
                  if (monthWiseActual[singleMonthObj.yearMonth] === undefined) {
                    monthWiseActual[singleMonthObj.yearMonth] = 0;
                  }
                  monthWiseTarget[singleMonthObj.yearMonth] += Number(singleMonthData.sales_target);
                  monthWiseActual[singleMonthObj.yearMonth] += Number(singleMonthData.total_sales);

                } else if (index > 1) {

                  monthWiseTarget[singleMonthObj.yearMonth] = 0;
                  monthWiseActual[singleMonthObj.yearMonth] = 0;
                }
              })
            })
          })*/
          //==========================
          getLastSixMonths.map((singleMonthObj) => {
            saleTargetDetails.map((productWise, index) => {

              productWise.sale_target_achivement_detail.map((singleMonthData) => {
                if (singleMonthData.sales_target_month == singleMonthObj.yearMonth) {

                  // if(tableData[singleMonthObj.name] === undefined){
                  //   tableData[singleMonthObj.name] = []; //[productWise.product_name]['target']
                  // }
                  // if(tableData[singleMonthObj.name][productWise.product_name] === undefined){
                  //   tableData[singleMonthObj.name][productWise.product_name] = []; //
                  // }
                  // if(tableData[singleMonthObj.name][productWise.product_name]['target'] === undefined){
                  //   tableData[singleMonthObj.name][productWise.product_name]['target'] = []; //
                  // }
                  // if(tableData[singleMonthObj.name] === undefined){
                  //   tableData[singleMonthObj.name] = 0; //[productWise.product_name]['actual']
                  // }
                  // tableData[singleMonthObj.name][productWise.product_name]['target'] += Number(singleMonthData.sales_target);
                  // tableData[singleMonthObj.name] += Number(singleMonthData.total_sales);
                  //======
                  if (monthWiseTarget[singleMonthObj.yearMonth] === undefined) {
                    monthWiseTarget[singleMonthObj.yearMonth] = 0;
                  }
                  if (monthWiseActual[singleMonthObj.yearMonth] === undefined) {
                    monthWiseActual[singleMonthObj.yearMonth] = 0;
                  }
                  monthWiseTarget[singleMonthObj.yearMonth] += Number(singleMonthData.sales_target);
                  monthWiseActual[singleMonthObj.yearMonth] += Number(singleMonthData.total_sales);

                } else if (index > 1) {

                  monthWiseTarget[singleMonthObj.yearMonth] = 0;
                  monthWiseActual[singleMonthObj.yearMonth] = 0;
                }
              })
            })
          })

          var data2 = {
            labels,
            datasets: [
              {
                label: 'Actual',
                // data: labels.map(() => Math.floor(Math.random() * 100)),
                data: array_values(monthWiseActual),
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
              },
              {
                label: 'Target',
                // data: labels.map(() => Math.floor(Math.random() * 100)),
                data: array_values(monthWiseTarget),
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
              },
            ],
          };

          setData(data2);
          setHaveData(true);

          setLoading(false)
        }
      }
      catch (error) {
        console.error("Performance Error ")
      }

    }
    MyPerformance()
  }, [])

  return (
    <>
      <BreadCrumbSecttion pageTitle="My Performance" currentPageName="My Performance" />
      <section className='padTop50'>
        <Container>

          {haveData && <Bar options={options} data={data} />}

          {getLastSixMonths?.map((singleMonth, index) => {
            return <Col xs={12} key={index}>
              <Accordion defaultActiveKey="0" className="mb-3">
                <Accordion.Item eventKey={index} key={index}>
                  <Accordion.Header>
                    <div className="col-6">
                      <b className="text-primary">{singleMonth.name}</b>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    {haveData && <Table striped bordered hover>
                      <tbody>
                        <tr>
                          <th>Product</th>
                          <th>Actual</th>
                          <th>Target</th>
                        </tr>
                        {
                          saleTargetDetails.map((singleProduct) => {
                            return singleProduct.sale_target_achivement_detail?.map((monthWise) => {
                              if (monthWise.sales_target_month == singleMonth.yearMonth) {

                                return (<tr>
                                  <td>{singleProduct.product_name}</td>
                                  <td>{monthWise.total_sales}</td>
                                  <td>{monthWise.sales_target}</td>
                                </tr>)
                              }
                            })

                          })
                        }

                      </tbody>
                    </Table>
                    }
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          })}

        </Container>
      </section>

    </>
  )

}

export default Performance;